export { default as EmbeddedDeficiencyDetailHeader } from './EmbeddedDeficiencyDetailHeader';
export { default as EmbeddedDeficiencyDetailBody } from './EmbeddedDeficiencyDetailBody';
